/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function ThreeDSolutionsIcon(props) {
  return (
    <svg
      {...props}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 2.05759L3.05936 5.91391L9.9997 9.76928L16.9407 5.91366L10.0002 2.05759ZM11.0002 16.4133L11.0002 16.4036V11.5014L18.0002 7.61293V10.9133C18.0002 11.4656 18.448 11.9133 19.0002 11.9133C19.5525 11.9133 20.0002 11.4656 20.0002 10.9133V6.26511C19.9999 5.9799 19.9233 5.69996 19.7785 5.45427C19.6337 5.20881 19.4254 5.00609 19.1762 4.86778L10.7762 0.200777C10.5388 0.0690931 10.2718 0 10.0002 0C9.72873 0 9.46102 0.0694647 9.22357 0.201149L0.823575 4.86815C0.574448 5.00647 0.366776 5.20881 0.222029 5.45427C0.0771524 5.69995 0.000581768 5.9799 0.000244883 6.26511L0.000244167 15.5603C0.000192013 15.8458 0.0765318 16.1261 0.221352 16.3722C0.366253 16.6184 0.574424 16.8213 0.824244 16.9598L9.22424 21.6258C9.46168 21.7575 9.72873 21.8266 10.0002 21.8266C10.5525 21.8266 11.0002 21.3789 11.0002 20.8266V16.4133ZM18.4722 13.7649C18.3636 13.3161 17.962 13 17.5002 13C17.0385 13 16.6368 13.3161 16.5283 13.7649C16.3662 14.4349 16.0225 15.0473 15.5351 15.5348C15.0476 16.0223 14.4352 16.3659 13.7651 16.528C13.3163 16.6366 13.0002 17.0383 13.0002 17.5C13.0002 17.9617 13.3163 18.3634 13.7651 18.472C14.4352 18.6341 15.0476 18.9777 15.5351 19.4652C16.0225 19.9527 16.3662 20.5651 16.5283 21.2351C16.6368 21.6839 17.0385 22 17.5002 22C17.962 22 18.3636 21.6839 18.4722 21.2351C18.6343 20.5651 18.978 19.9527 19.4654 19.4652C19.9529 18.9777 20.5653 18.6341 21.2354 18.472C21.6841 18.3634 22.0002 17.9617 22.0002 17.5C22.0002 17.0383 21.6841 16.6366 21.2354 16.528C20.5653 16.3659 19.9529 16.0223 19.4654 15.5348C18.978 15.0473 18.6343 14.4349 18.4722 13.7649Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 2.05759L3.05936 5.91391L9.9997 9.76928L16.9407 5.91366L10.0002 2.05759ZM11.0002 16.4133L11.0002 16.4036V11.5014L18.0002 7.61293V10.9133C18.0002 11.4656 18.448 11.9133 19.0002 11.9133C19.5525 11.9133 20.0002 11.4656 20.0002 10.9133V6.26511C19.9999 5.9799 19.9233 5.69996 19.7785 5.45427C19.6337 5.20881 19.4254 5.00609 19.1762 4.86778L10.7762 0.200777C10.5388 0.0690931 10.2718 0 10.0002 0C9.72873 0 9.46102 0.0694647 9.22357 0.201149L0.823575 4.86815C0.574448 5.00647 0.366776 5.20881 0.222029 5.45427C0.0771524 5.69995 0.000581768 5.9799 0.000244883 6.26511L0.000244167 15.5603C0.000192013 15.8458 0.0765318 16.1261 0.221352 16.3722C0.366253 16.6184 0.574424 16.8213 0.824244 16.9598L9.22424 21.6258C9.46168 21.7575 9.72873 21.8266 10.0002 21.8266C10.5525 21.8266 11.0002 21.3789 11.0002 20.8266V16.4133ZM18.4722 13.7649C18.3636 13.3161 17.962 13 17.5002 13C17.0385 13 16.6368 13.3161 16.5283 13.7649C16.3662 14.4349 16.0225 15.0473 15.5351 15.5348C15.0476 16.0223 14.4352 16.3659 13.7651 16.528C13.3163 16.6366 13.0002 17.0383 13.0002 17.5C13.0002 17.9617 13.3163 18.3634 13.7651 18.472C14.4352 18.6341 15.0476 18.9777 15.5351 19.4652C16.0225 19.9527 16.3662 20.5651 16.5283 21.2351C16.6368 21.6839 17.0385 22 17.5002 22C17.962 22 18.3636 21.6839 18.4722 21.2351C18.6343 20.5651 18.978 19.9527 19.4654 19.4652C19.9529 18.9777 20.5653 18.6341 21.2354 18.472C21.6841 18.3634 22.0002 17.9617 22.0002 17.5C22.0002 17.0383 21.6841 16.6366 21.2354 16.528C20.5653 16.3659 19.9529 16.0223 19.4654 15.5348C18.978 15.0473 18.6343 14.4349 18.4722 13.7649Z"
        fill="url(#paint0_radial_15395_16524)"
        fillOpacity="0.5"
      />
      <defs>
        <radialGradient
          id="paint0_radial_15395_16524"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.11135 4.63361) rotate(2.15043) scale(36.4145 15.0005)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#497FFF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

ThreeDSolutionsIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default ThreeDSolutionsIcon
